/**
 * Franchise archive compare UI.
 */
(function ($) {
	'use strict';

	function formatMoneyLabel(value) {
		var n = Number(value) || 0;
		if (n >= 1000000) {
			return '$1M+';
		}
		return '$' + Math.round(n / 1000) + 'K';
	}

	function syncCount($root) {
		var max = Number($root.data('max')) || (window.dfdCompare && dfdCompare.max) || 4;
		var count = $root.find('[data-compare-selected] .franchise-compare-selected-item').length;
		var template = (window.dfdCompare && dfdCompare.i18n && dfdCompare.i18n.selected) || '%1$d / %2$d selected';
		$root.find('[data-compare-count]').text(
			template.replace('%1$d', String(count)).replace('%2$d', String(max))
		);
		return { count: count, max: max };
	}

	function selectedIds($root) {
		return $root
			.find('[data-compare-selected] .franchise-compare-selected-item')
			.map(function () {
				return String($(this).data('id'));
			})
			.get();
	}

	function refreshPickerVisibility($root) {
		var ids = selectedIds($root);
		$root.find('[data-compare-picker] .franchise-compare-picker-item').each(function () {
			var $item = $(this);
			var id = String($item.data('id'));
			var selected = ids.indexOf(id) !== -1;
			$item.toggleClass('is-selected', selected);
			if (selected) {
				$item.attr('hidden', 'hidden');
			} else if (!$item.hasClass('is-filtered')) {
				$item.removeAttr('hidden');
			}
		});
	}

	function addFranchise($root, id) {
		var state = syncCount($root);
		if (state.count >= state.max) {
			var msg = (window.dfdCompare && dfdCompare.i18n && dfdCompare.i18n.max) || 'You can compare up to %d franchises.';
			window.alert(msg.replace('%d', String(state.max)));
			return;
		}

		id = String(id);
		if (selectedIds($root).indexOf(id) !== -1) {
			return;
		}

		var $pickerItem = $root.find('[data-compare-picker] .franchise-compare-picker-item[data-id="' + id + '"]');
		if (!$pickerItem.length) {
			return;
		}

		var title = $pickerItem.data('title') || '';
		var logo = $pickerItem.find('.franchise-compare-picker-logo').html() || title.charAt(0);

		var $li = $(
			'<li class="franchise-compare-selected-item" data-id="' +
				id +
				'">' +
				'<span class="franchise-compare-selected-logo"></span>' +
				'<span class="franchise-compare-selected-name"></span>' +
				'<button type="button" class="franchise-compare-selected-remove" data-compare-remove="' +
				id +
				'" aria-label="Remove">×</button>' +
				'<input type="hidden" name="compare[]" value="' +
				id +
				'" />' +
				'</li>'
		);
		$li.find('.franchise-compare-selected-logo').html(logo);
		$li.find('.franchise-compare-selected-name').text(title);
		$root.find('[data-compare-selected]').append($li);

		refreshPickerVisibility($root);
		syncCount($root);
	}

	function removeFranchise($root, id) {
		id = String(id);
		$root.find('[data-compare-selected] .franchise-compare-selected-item[data-id="' + id + '"]').remove();
		refreshPickerVisibility($root);
		syncCount($root);
	}

	function applyFilters($root) {
		var minInvest = Number($root.find('[data-range-min]').val()) || 0;
		var maxInvest = Number($root.find('[data-range-max]').val()) || 1000000;
		var feeRange = String($root.find('[data-filter-fee]').val() || '');
		var statesRange = String($root.find('[data-filter-states]').val() || '');
		var type = String($root.find('[data-filter-type]').val() || '');
		var models = $root
			.find('[data-filter-model]:checked')
			.map(function () {
				return String($(this).val());
			})
			.get();

		var feeMin = 0;
		var feeMax = Infinity;
		if (feeRange) {
			var feeParts = feeRange.split('-');
			feeMin = Number(feeParts[0]) || 0;
			feeMax = Number(feeParts[1]) || Infinity;
		}

		var statesMin = 0;
		var statesMax = Infinity;
		if (statesRange) {
			var stateParts = statesRange.split('-');
			statesMin = Number(stateParts[0]) || 0;
			statesMax = Number(stateParts[1]) || Infinity;
		}

		$root.find('[data-compare-picker] .franchise-compare-picker-item').each(function () {
			var $item = $(this);
			var investMin = Number($item.data('invest-min')) || 0;
			var investMax = Number($item.data('invest-max')) || investMin;
			var fee = Number($item.data('fee')) || 0;
			var itemType = String($item.data('type') || '');
			var itemModels = String($item.data('models') || '')
				.split(',')
				.filter(Boolean);
			var states = Number($item.data('states')) || 0;

			var ok = true;
			if (investMax < minInvest || investMin > maxInvest) {
				ok = false;
			}
			if (ok && feeRange && (fee < feeMin || fee > feeMax)) {
				ok = false;
			}
			if (ok && statesRange && (states < statesMin || states > statesMax)) {
				ok = false;
			}
			if (ok && type && itemType !== type) {
				ok = false;
			}
			if (ok && models.length) {
				ok = models.some(function (m) {
					return itemModels.indexOf(m) !== -1;
				});
			}

			$item.toggleClass('is-filtered', !ok);
			if (!ok || $item.hasClass('is-selected')) {
				$item.attr('hidden', 'hidden');
			} else {
				$item.removeAttr('hidden');
			}
		});
	}

	function initRange($root) {
		var $min = $root.find('[data-range-min]');
		var $max = $root.find('[data-range-max]');
		var $minLabel = $root.find('[data-range-min-label]');
		var $maxLabel = $root.find('[data-range-max-label]');
		var params = new URLSearchParams(window.location.search);
		var urlMin = params.get('invest_min');
		var urlMax = params.get('invest_max');
		var sliderMin = Number($min.attr('min')) || 0;
		var sliderMax = Number($min.attr('max')) || 1000000;

		if (urlMin !== null && urlMin !== '') {
			$min.val(Math.max(sliderMin, Math.min(sliderMax, Number(urlMin) || 0)));
		}
		if (urlMax !== null && urlMax !== '') {
			$max.val(Math.max(sliderMin, Math.min(sliderMax, Number(urlMax) || sliderMax)));
		}

		function update() {
			var minVal = Number($min.val());
			var maxVal = Number($max.val());
			if (minVal > maxVal) {
				var tmp = minVal;
				minVal = maxVal;
				maxVal = tmp;
				$min.val(minVal);
				$max.val(maxVal);
			}
			$minLabel.text(formatMoneyLabel(minVal));
			$maxLabel.text(formatMoneyLabel(maxVal));
			applyFilters($root);
		}

		$min.on('input change', update);
		$max.on('input change', update);
		update();
	}

	function initCats($root) {
		var $links = $root.find('[data-compare-cat]');
		if (!$links.length || !('IntersectionObserver' in window)) {
			$links.on('click', function () {
				$links.removeClass('is-active');
				$(this).addClass('is-active');
			});
			return;
		}

		var sections = $root.find('[data-compare-section]').toArray();
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) {
						return;
					}
					var id = entry.target.getAttribute('data-compare-section');
					$links.removeClass('is-active');
					$links.filter('[href="#compare-' + id + '"]').addClass('is-active');
				});
			},
			{ rootMargin: '-20% 0px -60% 0px', threshold: 0.1 }
		);

		sections.forEach(function (section) {
			observer.observe(section);
		});
	}

	$(function () {
		var $root = $('[data-franchise-compare]');
		if (!$root.length) {
			return;
		}

		initRange($root);
		initCats($root);
		refreshPickerVisibility($root);
		syncCount($root);

		$root.on('click', '[data-compare-add]', function () {
			addFranchise($root, $(this).data('compare-add'));
		});

		$root.on('click', '[data-compare-remove]', function () {
			removeFranchise($root, $(this).data('compare-remove'));
		});

		$root.on('click', '[data-compare-clear]', function () {
			$root.find('[data-compare-selected]').empty();
			refreshPickerVisibility($root);
			syncCount($root);
		});

		$root.on('change input', '[data-filter-fee], [data-filter-states], [data-filter-type], [data-filter-model]', function () {
			applyFilters($root);
		});

		$root.on('click', '[data-compare-share]', function () {
			var ids = selectedIds($root);
			var archive = (window.dfdCompare && dfdCompare.archive) || window.location.href.split('?')[0];
			var shareUrl = ids.length ? archive + (archive.indexOf('?') === -1 ? '?' : '&') + 'compare=' + encodeURIComponent(ids.join(',')) : archive;
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(shareUrl).catch(function () {});
			}
			window.prompt('Share this comparison:', shareUrl);
		});
	});
})(jQuery);
